<template>
  <div>
    <v-dialog :value="isActive" persistent max-width="1000" scrollable>
      <ValidationObserver v-slot="{ handleSubmit }">
        <v-card :loading="isLoading">
          <v-card-title class="pa-0 shadow-1">
            <v-img
              :src="require('@/assets/illustrations/bg_modal_card.svg')"
              cover
              position="left bottom"
              class="align-center"
              height="65px"
            >
              <v-card-title class="font-weight-medium primary--text">
                Detalles
              </v-card-title>
            </v-img>
          </v-card-title>

          <vuescroll
            :ops="{
              bar: { background: '#bacfcec0', keepShow: true }
            }"
          >
            <v-card-text style="max-height: 450px">
              <v-row>
                <!-- Nombre -->
                <v-col cols="12" class="pb-0">
                  <v-list-item two-line>
                    <v-list-item-content>
                      <v-list-item-subtitle>Título</v-list-item-subtitle>
                      <div>{{ data.title }}</div>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item two-line>
                    <v-list-item-content>
                      <v-list-item-subtitle
                        >Mensaje inicial</v-list-item-subtitle
                      >
                      <div>{{ data.initial_message }}</div>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item two-line>
                    <v-list-item-content>
                      <v-list-item-subtitle
                        >Mensaje de despedida</v-list-item-subtitle
                      >
                      <div>{{ data.end_message }}</div>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item two-line>
                    <v-list-item-content>
                      <v-list-item-subtitle>Estado</v-list-item-subtitle>
                      <div>{{ data.status }}</div>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>

                <!-- Preguntas -->
                <v-col cols="12" class="pb-0">
                  <h6>Listado de preguntas</h6>
                  <v-data-table
                    :headers="headers"
                    :items="optionsList.questions"
                    item-key="id"
                    :loading="isLoading"
                    :footer-props="{
                      'items-per-page-options': [15, 30, 50, 100]
                    }"
                  >
                    <template v-slot:[`item.action`]="{ item }">
                      <v-hover v-slot:default="{ hover }">
                        <v-btn
                          text
                          icon
                          :color="hover ? 'accent' : 'blue-grey'"
                          @click.stop="handleEdit(item)"
                        >
                          <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                      </v-hover>

                      <v-hover v-slot:default="{ hover }">
                        <v-btn
                          text
                          icon
                          :color="hover ? 'error' : 'blue-grey'"
                          @click.stop="handleDelete(item.id)"
                        >
                          <v-icon>mdi-trash-can-outline</v-icon>
                        </v-btn>
                      </v-hover>
                    </template>
                  </v-data-table>
                  <!-- <v-list-item
                  two-line
                  v-for="(item, index) in optionsList"
                  :key="index"
                >
                  <v-list-item-content>
                    <v-list-item-subtitle>Mensaje</v-list-item-subtitle>
                    <div>{{ item.message }}</div>
                  </v-list-item-content>
                </v-list-item> -->
                </v-col>
              </v-row>
            </v-card-text>
          </vuescroll>
          <v-card-actions>
            <v-btn
              @click="closeDialog()"
              class="px-8"
              color="error"
              rounded
              large
              text
            >
              Cerrar
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </ValidationObserver>
    </v-dialog>

    <newOptionForm
      v-if="isOptionEditMode"
      :isActive="isOptionEditMode"
      :dataToEdit="eventToEdit"
      :isEditMode="isOptionEditMode"
      @close:dialog="closeOptionFormDialog"
    ></newOptionForm>
  </div>
</template>

<script>
import axios from "axios";
import vuescroll from "vuescroll";
import newOptionForm from "./newFormOptions.vue";
import { PbxHttpClient } from "@/services/httpclient";

export default {
  components: {
    vuescroll,
    newOptionForm
  },

  props: {
    isActive: {
      type: Boolean
    },
    isOptionEditMode: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: {}
    }
  },

  data() {
    return {
      isLoading: false,
      isOptionEditMode: false,
      optionsList: [],
      eventToEdit: {},
      payload: {
        name: "",
        menu_message: "",
        return_message: "",
        initial_message: "",
        closing_time_sg: null,
        goodbye_message: "",
        closing_queue: null,
        use: null
      },

      headers: [
        {
          text: "Pregunta",
          align: "left",
          value: "question",
          class: "primary--text",
          width: "85%"
        },
        {
          text: "Acciones",
          value: "action",
          class: "primary--text",
          width: "15%",
          align: "left",
          sortable: false
        }
      ]
    };
  },

  mounted() {
    this.getSelectsInfo();
  },

  methods: {
    closeDialog(data = false) {
      this.$emit("close:dialog", data);
    },

    closeOptionFormDialog() {
      this.getSelectsInfo();
      this.isOptionEditMode = false;
      this.eventToEdit = {};
    },

    handleEdit(item) {
      this.eventToEdit = item;
      this.isOptionEditMode = true;
    },

    async getSelectsInfo() {
      // this.isLoading = true;

      // const accessToken = localStorage.getItem("token");

      let endpoints = [`/survey_chats/${this.data.id}`];

      await axios
        .all(
          endpoints.map((endpoint) =>
            PbxHttpClient.get(
              endpoint
              // {
              //   headers: {
              //     Authorization: `Bearer ${accessToken}`,
              //   },
              // }
            )
          )
        )
        .then((res) => {
          this.optionsList = res[0].data;
          // console.log("Listo", res);
        })
        .catch((error) => {
          // console.error(error);
          this.$snotify.error("Hubo un error en la consulta.", "Error");
        });
      // .finally(() => {
      //   this.isLoading = false;
      // });
    },

    async handleDelete(event) {
      // const accessToken = localStorage.getItem("token");

      try {
        const confirmRequest = await this.$swalconfirm(
          "Confirmar",
          `Está seguro de eliminar este evento? Ésta acción no es reversible.`
        );
        if (confirmRequest.isConfirmed) {
          PbxHttpClient.delete(`/questions_chat/${event}/destroy`)
            .then((res) => {
              const index = this.optionsList.questions.findIndex(
                (el) => el.id === res.data.question
              );
              this.optionsList.questions.splice(index, 1);

              this.$snotify.success("Pregunta eliminada", "¡Hecho!");
            })
            .catch((error) => {
              // console.error(error);
              this.$snotify.error("Hubo un error al eliminar.", "Error");
            });
        }
      } catch (error) {
        this.$snotify.error("No se pudo eliminar.", "¡Error!");
        // console.error(error);
      }
    }
  }
};
</script>
